export const filterEntitiesByEntityId = (entities, entityId) => {
  return entities.filter((entity) => entity.id === entityId);
};
